var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    transform: "translate(-325.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(325.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    fillRule: "nonzero",
    id: "\\u8DEF\\u5F84",
    points: "24 0 0 0 0 24 24 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "22 7 12 2 2 7 2 17 12 22 22 17",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 2,
    x2: 12,
    y1: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 12,
    x2: 12,
    y1: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 22,
    x2: 12,
    y1: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 17,
    x2: 7,
    y1: 4.5,
    y2: 9.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiIcon);
export default __webpack_public_path__ + "static/media/pi_icon.b65e41ab8b5334b5e2c600a6247c2642.svg";
export { ForwardRef as ReactComponent };